/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { lifeSubNavMenuAction } from '../../../common/actions/lifePageSubNavigationActions';
import { LifeTitle, LifeTitleH1 } from './lifeTitle';
import { ArrowIcon } from '../utilities/arrowIcon';
import { withScreenSize } from '../utilities/withScreenSize.jsx';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface LifePageContentTitleProps {
    pageTitle: string;
    arrowStrokeColor: string;
    isDesktop: boolean;
    lifeSubNavMenuAction(isOpen: boolean): void;
    showTitleAsH1?: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    return {};
};

const mapDispatchToProps = {
    lifeSubNavMenuAction
};
export const LifePageContentTitle = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    pageTitle,
    isDesktop,
    arrowStrokeColor='#ffffff',
    lifeSubNavMenuAction,
    showTitleAsH1 = false
}: LifePageContentTitleProps) => {

    return  (
        <TitleContainer>
            {showTitleAsH1 ? <LifeTitleH1>{pageTitle}</LifeTitleH1> : <LifeTitle>{pageTitle}</LifeTitle>}
            {!isDesktop
                && <ArrowContainer onClick={() => lifeSubNavMenuAction(true)}>
                    <ArrowIcon strokeColor={arrowStrokeColor}/>
                </ArrowContainer>
            }
        </TitleContainer>
    );
})));

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    @media ${smallMediaQuery} {
        justify-content: center;
    }
`;

const ArrowContainer = styled.div`
    width: 48px;
    height: 48px;
    fill: white;
    margin: 15px 0 0 10px;
`;
